module.exports = __webpack_public_path__ + "img/join_result.ada1493e.png";